module.exports = __webpack_public_path__ + "img/price.2006e0ea.svg";